import React, { createContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [cartTotal, setCartTotal] = useState(0);

  useEffect(() => {
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      setCartItems(JSON.parse(savedCart));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cartItems));
    updateCartSummary();
  }, [cartItems]);

  const updateCartSummary = () => {
    const count = cartItems.reduce((sum, item) => sum + item.quantity, 0);
    const total = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    setCartCount(count);
    setCartTotal(total);
  };

  const addToCart = (product, size, color, quantity = 1) => {
    setCartItems(prevItems => {
      const existingItem = prevItems.find(
        item => item.id === product.id && item.size === size && item.color === color
      );

      if (existingItem) {
        toast.success(`Updated ${product.title} quantity in cart`);
        return prevItems.map(item =>
          item.id === product.id && item.size === size && item.color === color
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }

      toast.success(`Added ${product.title} to cart`);
      return [...prevItems, {
        id: product.id,
        title: product.title,
        price: product.discount_price || product.original_price,
        original_price: product.original_price,
        image: product.main_image,
        size,
        color,
        quantity,
        stock: product.stock_quantity
      }];
    });
  };

  const removeFromCart = (id, size, color) => {
    setCartItems(prevItems => {
      const newItems = prevItems.filter(
        item => !(item.id === id && item.size === size && item.color === color)
      );
      toast.success('Item removed from cart');
      return newItems;
    });
  };

  const updateQuantity = (id, size, color, quantity) => {
    if (quantity < 1) {
      removeFromCart(id, size, color);
      return;
    }

    setCartItems(prevItems =>
      prevItems.map(item =>
        item.id === id && item.size === size && item.color === color
          ? { ...item, quantity }
          : item
      )
    );
  };

  const clearCart = () => {
    setCartItems([]);
    toast.success('Cart cleared');
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        cartCount,
        cartTotal,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};